import React, { useRef } from 'react';
import LibraryDialog from '../../Library/LibraryDialog';

/**
 * Removing a user asks first, as archiving does (ArchiveConfirmDialog): users
 * are the one thing removed rather than archived (ResUI Design Decisions,
 * Content). The question is the prototype's. Focus starts on Cancel.
 */
function RemoveUserDialog({ user, opener, fallbackFocus, onConfirm, onClose }) {
  const cancelRef = useRef(null);
  return (
    <LibraryDialog title="Remove user?" size="confirm" initialFocus={cancelRef} opener={opener} fallbackFocus={fallbackFocus} onClose={onClose}>
      <p className="library-dialog-text">Remove {user.name} from the organization?</p>
      <div className="library-dialog-actions">
        <button ref={cancelRef} type="button" className="resui-btn resui-btn--secondary" onClick={onClose}>Cancel</button>
        <button type="button" className="resui-btn resui-btn--destructive" onClick={onConfirm}>Remove user</button>
      </div>
    </LibraryDialog>
  );
}

export default RemoveUserDialog;
